import { render, staticRenderFns } from "./returnSupplier.vue?vue&type=template&id=f312e95e&scoped=true"
import script from "./returnSupplier.vue?vue&type=script&lang=js"
export * from "./returnSupplier.vue?vue&type=script&lang=js"
import style0 from "./returnSupplier.vue?vue&type=style&index=0&id=f312e95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f312e95e",
  null
  
)

export default component.exports